/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  circleColor?: string;
  crossColor?: string;
}
const CircularCrossIcon = ({
  circleColor = 'currentColor',
  crossColor = 'currentColor',
  ...props
}: IconProps) => (
  <svg
    width={60}
    height={60}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="CircularCrossIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 57.5c15.188 0 27.5-12.312 27.5-27.5S45.188 2.5 30 2.5 2.5 14.812 2.5 30 14.812 57.5 30 57.5Zm0 2.5c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30Z"
      fill={circleColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.476 20.064a1.25 1.25 0 0 1 1.767 0l8.169 8.168 7.757-7.757a1.25 1.25 0 0 1 1.768 1.768L32.18 30l7.757 7.757a1.25 1.25 0 0 1-1.768 1.768l-7.757-7.757-8.169 8.169a1.25 1.25 0 0 1-1.767-1.768L28.643 30l-8.168-8.169a1.25 1.25 0 0 1 0-1.767Z"
      fill={crossColor}
    />
  </svg>
);

export default CircularCrossIcon;
